import { render, staticRenderFns } from "./IconIos.vue?vue&type=template&id=37fd503c&"
import script from "./IconIos.vue?vue&type=script&lang=js&"
export * from "./IconIos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports